import { ChangeDetectionStrategy, Component } from '@angular/core';
import { StatistikService } from '../../statistik.service';
import { filter, map, switchMap } from 'rxjs/operators';
import { combineLatest, Observable, Subject } from 'rxjs';
import { StatistikTidsforbrugViewModel } from '../../models/statistikTidsforbrugViewModel';

@Component({
    selector: 'app-statistik-tidsforbrug',
    template: `<app-statistik-tidsforbrug-ui
        [uproduktiveSager]="uproduktiveSager$ | async"
        [medarbejdere]="StatistikTidsforbrugMedarbejder$ | async"
        (periodeChange)="periodeChange($event)"
        [periode]="periode$ | async"
    ></app-statistik-tidsforbrug-ui>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikTidsforbrugContainerComponent {
    periodeSubject = new Subject<{fra: string, til: string}>();
    periode$ = this.periodeSubject.asObservable();
    uproduktiveSager$ = this.statistikService.getStatistikUproduktivesager().pipe(
        map(sager => sager.sort((a, b) => a.beskrivelse.localeCompare(b.beskrivelse)))
    );
    StatistikTidsforbrugMedarbejder$: Observable<StatistikTidsforbrugViewModel[]> = combineLatest([
        this.statistikService.visible$,
        this.statistikService.step$,
        this.periode$
    ]).pipe(
        filter(([visible, step]) => visible && step === 2),
        switchMap(([, , periode]) => this.statistikService.getTidsforbrug(periode))
    );

    constructor(
        private statistikService: StatistikService
    ) { }

    periodeChange(periode: {fra: string; til: string}) {
        this.periodeSubject.next(periode);
    }
}

